import axios from "axios";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

if (!API_BASE_URL) {
  console.warn("Missing REACT_APP_API_BASE_URL in .env.local");
}

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  // 🔴 NU trimitem access token la logout
  if (config.url?.includes("/authen/logout")) {
    return config;
  }

  const token =
    sessionStorage.getItem("access")
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default api;
